import AppLink from '@/components/common/AppLink';
import styles from './styles.module.css';
import { Tags } from '@/commonTypes';

export default function MostSearchedItem({
  item,
  index,
  searchKey,
}: {
  item?: Tags;
  index: number;
  searchKey?: string;
}) {
  return (
    <AppLink className={styles.button} href={`/search?${searchKey}=${item?.title}`}>
      <span className={styles.index}>{index + 1}</span>

      <span className={styles.content}>
        <span className={styles.title}>{item?.title}</span>
        <span className={styles.searches}>
          <span>{item?.count}</span> جستجو
        </span>
      </span>
    </AppLink>
  );
}
